/**
 * @ngdoc service
 * @name dwtModule.DwtProgressService
 * @description This is a service used for progress bar in general meeting view
 * @requires $sessionStorage to store/pass session data
 * @requires $filter
 */
import { formatDateCustom } from '@/lib/date';

angular.module('dwtModule').service('DwtProgressService', [
  '$sessionStorage',
  '$filter',
  function ($sessionStorage, $filter) {
    this.getDWTScheduleProgressData = function (dwtScheduleInfo, userType) {
      let progressData = [];

      if (dwtScheduleInfo.dividendPaymentDate && dwtScheduleInfo.dividendPaymentDate !== '01 Jan 1970') {
        progressData.push({
          label: 'label_dividendPaymentDate',
          value: dwtScheduleInfo.dividendPaymentDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.dividendPaymentDate),
        });
      }
      if (dwtScheduleInfo.dividendRecordDate && dwtScheduleInfo.dividendRecordDate !== '01 Jan 1970') {
        progressData.push({
          label: 'label_dividendRecordDate',
          value: dwtScheduleInfo.dividendRecordDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.dividendRecordDate),
        });
      }
      if (this.shouldDisplayFirstRasPaymentDateIssuer(dwtScheduleInfo, userType)) {
        progressData.push({
          label: 'label_firstRasPaymentDateIssuerShort',
          value: formatDateCustom(dwtScheduleInfo.firstRasPaymentDateIssuer, 'D MMM YYYY', 'en'),
          isPastDue: this.isPastDue(dwtScheduleInfo.firstRasPaymentDateIssuer),
        });
      }
      if (this.shouldDisplayFirstRasPaymentDateIntermediary(dwtScheduleInfo, userType)) {
        progressData.push({
          label: 'label_firstRasPaymentDateIntermediaryShort',
          value: formatDateCustom(dwtScheduleInfo.firstRasPaymentDateIntermediary, 'D MMM YYYY', 'en'),
          isPastDue: this.isPastDue(dwtScheduleInfo.firstRasPaymentDateIntermediary),
        });
      }
      if (dwtScheduleInfo.qrfReclaimStartDate && dwtScheduleInfo.qrfReclaimStartDate !== '01 Jan 1970') {
        progressData.push({
          label: 'label_reclaimStartDate',
          claimTypeLabel: 'label_claimRas',
          value: dwtScheduleInfo.qrfReclaimStartDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.qrfReclaimStartDate),
        });
      }
      if (dwtScheduleInfo.qrfReclaimEndDate && dwtScheduleInfo.qrfReclaimEndDate !== '01 Jan 1970 00:00') {
        progressData.push({
          label: 'label_reclaimEndDate',
          claimTypeLabel: 'label_claimRas',
          value: dwtScheduleInfo.qrfReclaimEndDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.qrfReclaimEndDate),
        });
      }
      if (dwtScheduleInfo.peStartDate && dwtScheduleInfo.peStartDate !== '01 Jan 1970') {
        progressData.push({
          label: 'label_reclaimStartDate',
          claimTypeLabel: 'label_claimWht',
          value: dwtScheduleInfo.peStartDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.peStartDate),
        });
      }
      if (dwtScheduleInfo.peEndDate && dwtScheduleInfo.peEndDate !== '01 Jan 1970 00:00') {
        progressData.push({
          label: 'label_reclaimEndDate',
          claimTypeLabel: 'label_claimWht',
          value: dwtScheduleInfo.peEndDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.peEndDate),
        });
      }
      if (dwtScheduleInfo.rePaymentTaxDate && dwtScheduleInfo.rePaymentTaxDate !== '01 Jan 1970') {
        progressData.push({
          label: 'label_dateRepaymentTaxAuthority',
          value: dwtScheduleInfo.rePaymentTaxDate,
          isPastDue: this.isPastDue(dwtScheduleInfo.rePaymentTaxDate),
        });
      }

      angular.forEach(progressData, function (data) {
        data.dateValue = new Date(data.value);
      });
      let sortedArray = $filter('orderBy')(progressData, 'dateValue', false);
      angular.forEach(sortedArray, function (data) {
        if (data.label === 'label_reclaimEndDate' && data.value !== undefined) {
          data.value = data.value + ' ' + 'CET';
        }
      });
      return sortedArray;
    };

    this.getProgressClass = function (isPastDue, index) {
      let classes = [];

      classes.push(isPastDue ? 'success-color' : 'warning-color');

      const columnClasses = [
        'colOne', 'colTwo', 'colThree', 'colFour', 'colFive',
        'colSix', 'colSeven', 'colEight', 'colNine', 'colTen'
      ];
      if (index >= 0 && index < columnClasses.length) {
        classes.push(columnClasses[index]);
      }

      return classes;
    };

    this.isPastDue = function (dateString) {
      const reference = new Date(dateString).getTime();
      const now = new Date().getTime();

      return now >= reference;
    };

    this.shouldDisplayFirstRasPaymentDateIssuer = function (schedule, userType) {
      // is correct user type
      if ('IS' !== userType && 'AG' !== userType) {
        return false;
      }

      // has a value
      if (!schedule.firstRasPaymentDateIssuer) {
        return false;
      }

      // value is no different from the ras reclaim end date
      return this.hasIntermediaryPayment(schedule);
    };

    this.shouldDisplayFirstRasPaymentDateIntermediary = function (schedule, userType) {

      // is correct user type
      if ('IN' !== userType && 'AG' !== userType) {
        return false;
      }

      // has a value
      if (!schedule.firstRasPaymentDateIntermediary) {
        return false;
      }

      // value is no different from the ras reclaim end date
      return this.hasIntermediaryPayment(schedule);

    };

    this.hasIntermediaryPayment = function (schedule) {
      const date = new Date(schedule.qrfReclaimEndDate)
        .toISOString().split('T')[0];

      return schedule.firstRasPaymentDateIssuer !== date;
    };

  },
]);
